module.exports = __webpack_public_path__ + "body-goal-incomplete.png";